import React, {  useEffect,useContext } from "react";
import TechGPT from "./TechGPT";

const KBTechArticles = ({content}) => {
    // Handle change division dropdown option
    return (    
       <TechGPT content={content}></TechGPT> 
    // <p>hii</p>
    );
};
export default KBTechArticles;